import type { Wallet, WalletType } from '../../../../schema/frameworks/entry.js';
import {
  AuthenticatedError,
  type IAuthorizedUseCase,
  type IGetPlayerAccountBalanceUseCase,
  NotImplementedError,
} from '../../../domain/entry.js';

export type IGetAccountBalanceController = ReturnType<typeof getAccountBalanceController>;

type ControllerProps = {
  walletType?: WalletType;
};

/**
 * Creates a controller for retrieving player account balance.
 *
 * @param getPlayerAccountBalanceUseCase - The use case for getting player account balance
 * @param isRoleUseCase - The use case for checking user roles
 * @returns An async function that retrieves and returns the account balance data
 */
export function getAccountBalanceController(
  getPlayerAccountBalanceUseCase: IGetPlayerAccountBalanceUseCase,
  isRoleUseCase: IAuthorizedUseCase
) {
  return async function controller({ walletType }: ControllerProps): Promise<Wallet> {
    const isUserRole = await isRoleUseCase.execute({ role: 'Player' });
    if (!isUserRole) {
      throw new AuthenticatedError('User not signed in');
    }
    let data;
    if (walletType === 'WALLET_PLAYER') {
      data = await getPlayerAccountBalanceUseCase.execute();
    } else {
      throw new NotImplementedError(`Wallet type ${walletType} is not supported yet.`);
    }

    return data;
  };
}
